import * as ContactUsV1 from "./V1";
import * as ContactUsV2 from "./V2";

export { ContactUsV1, ContactUsV2 };



// WEBPACK FOOTER //
// ./src/pages/ContactUs/index.js